
// @mui material components
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import {

  Card,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,

} from "@mui/material";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";


import VuiInput from "components/VuiInput";

import GradientBorder from "examples/GradientBorder";

// Vision UI Dashboard assets

import VuiButton from "components/VuiButton";

import TokenData from "./tokenData";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import TokenCards from "examples/tokenCards/tokenCards";

import MarketChart from "examples/Charts/MarketChart/MarketChart";
import { formatTimeDifference } from "utilities/utilites";
import { shortenAddress } from "utilities/utilites";
import { formatCurrency } from "utilities/utilites";
import { getChainIcon } from "utilities/utilites";
import contractABI from "../../assets/contractABI.json";
import { useWallet } from "WalletProvider";
import { getChainName } from "utilities/utilites";
import { ethers } from "ethers";
import { getTokenDecimals } from "utilities/utilites";
import { getCurrentFee } from "utilities/utilites";
import { readContract, writeContract } from "@wagmi/core";
import { config } from "index";
import { getDexName } from "utilities/utilites";
import { ConnectKitButton } from "connectkit";
import { Bounce, toast } from "react-toastify";
import { base } from "viem/chains";

const validationSchema = yup.object().shape({
  marketName: yup.string().required("Market Name is required"),
  masterTokenName: yup.string().required("Mother Token is required"),
  motherTvl: yup
    .number()
    .typeError("Cannot be empty")
    .positive("Must be positive")
    .required("Required"),
  childTokenName: yup.string().required("Child Token is required"),
  childTvl: yup
    .number()
    .typeError("Cannot be empty")
    .positive("Must be positive")
    .required("Required"),
});

function MarketCreate() {

  const [masterToken, setMasterToken] = useState({});
  const [masterTokenName, setMasterTokenName] = useState("");
  const [childToken, setChildToken] = useState({});
  const [childTokenName, setChildTokenName] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [defaultTokens, setDefaultTokens] = useState([]);
  const [activeField, setActiveField] = useState("");
  const { wallet, selectedChain } = useWallet();

  const [loading, setLoading] = useState(false);
  // const { data: hash, writeContract } = useWriteContract()

  // Fetch default token profiles when the modal opens & no search query
  // Fetch default tokens when dialog opens and search is empty
  useEffect(() => {
    if (searchOpen && searchQuery === "") {
      setLoading(true);
      fetch("https://api.dexscreener.com/token-profiles/latest/v1")
        .then((res) => res.json())
        .then((data) => {
          // setDefaultTokens(data || []);
          setDefaultTokens((data || []).filter((token) => token.chainId === "base"));
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [searchOpen, searchQuery]);

  // Fetch search results dynamically
  useEffect(() => {
    if (searchQuery !== "") {
      setLoading(true);

      const delayDebounceFn = setTimeout(() => {
        fetch(`https://api.dexscreener.com/latest/dex/search?q=${searchQuery}`)
          .then((res) => res.json())
          .then((data) => {
            // setSearchResults(data.pairs || []);
            setSearchResults((data.pairs || []).filter((token) => token.chainId === "base"));
            setLoading(false);
          })
          .catch(() => setLoading(false));
      }, 500); // 500ms debounce to reduce API calls

      return () => clearTimeout(delayDebounceFn);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery]);

  const handleSearchOpen = (field) => {
    setActiveField(field);
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
    setSearchQuery("");
    setSearchResults([]);
  };

  const fetchTokenHolders = async (contractAddress, chainId) => {
    try {
      const response = await fetch(
        `https://api.chainbase.online/v1/token/holders?chain_id=${chainId}&contract_address=${contractAddress}`,
        {
          method: "GET",
          headers: {
            "x-api-key": "2tOuyOhPX3D1Y8E5lh9tsXxvfCC", // Replace with your actual API key
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      
      return data?.count || 0; // Returns the count of holders
    } catch (error) {
      console.error("Error fetching token holders:", error);
      return 0; // Fallback to 0 in case of an error
    }
  };

  const handleSelectToken = (token) => {
    // First, check if the token is already selected in the other field
    if (activeField === "master") {
      // Check if this token is already selected as child token
      if (
        childToken.baseToken?.address &&
        token.baseToken.address === childToken.baseToken.address
      ) {
        toast.error("You cannot select the same token for both Mother and Child positions");
        return;
      }

      // Immediately update UI with available token data
      const initialToken = {
        ...token,
        holdersCount: 0, // Placeholder until real data arrives
      };

      setMasterToken(initialToken);
      setMasterTokenName(token?.baseToken?.name);
      setValue("masterTokenName", token?.baseToken?.name);
    } else {
      // Check if this token is already selected as master token
      if (
        masterToken.baseToken?.address &&
        token.baseToken.address === masterToken.baseToken.address
      ) {
        toast.error("You cannot select the same token for both Mother and Child positions");
        return;
      }

      // Immediately update UI with available token data
      const initialToken = {
        ...token,
        holdersCount: 0, // Placeholder until real data arrives
      };

      setChildToken(initialToken);
      setChildTokenName(token?.baseToken?.name);
      setValue("childTokenName", token?.baseToken?.name);
    }

    // Close the modal immediately
    handleSearchClose();

    // Fetch holders count in the background
    fetchTokenHolders(token.baseToken.address, getChainName(token.chainId))
      .then((holdersCount) => {
        

        // Update the token object with the fetched holders count
        const updatedToken = {
          ...token,
          holdersCount,
        };

        // Update state without blocking UI
        if (activeField === "master") {
          setMasterToken(updatedToken);
        } else {
          setChildToken(updatedToken);
        }
      })
      .catch((error) => {
        console.error("Error fetching holders count:", error);
        // Optionally show an error toast but don't block the flow
        toast.warn("Couldn't fetch holders count. Some data may be incomplete.");
      });
  };

  const {
    watch,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const mothertvlAmount = watch("motherTvl", 0); // Watching input changes

  const childtvlAmount = watch("childTvl", 0); // Watching input changes
  // 
  const onSubmit = async (data) => {
    
    
    

    // Fetch decimals for mother and child tokens
    const motherDecimals = await getTokenDecimals(
      masterToken.baseToken.address,
      getChainName(masterToken.chainId)
    );
    const childDecimals = await getTokenDecimals(
      childToken.baseToken.address,
      getChainName(masterToken.chainId)
    );

    const requiredFee = await getCurrentFee();
    const marketData = {
      name: data.marketName,
      motherTVL: ethers.utils.parseUnits(data.motherTvl.toString(), motherDecimals),
      motherToken: masterToken.baseToken.address, // WSTETH
      motherQuoteToken: masterToken.quoteToken.address,
      motherChain: getChainName(masterToken.chainId),
      motherDex: getDexName(selectedChain, masterToken.dexId),
      motherPairAddress: masterToken.pairAddress,
      childTVL: ethers.utils.parseUnits(data.childTvl.toString(), childDecimals),
      childToken: childToken.baseToken.address, // USDT
      childQuoteToken: childToken.quoteToken.address,
      childChain: getChainName(childToken.chainId),
      childDex: getDexName(selectedChain, childToken.dexId),
      childPairAddress: childToken.pairAddress,
      baseChain: selectedChain
    };
    

    try {
      const message = await writeContract(config, {
        abi: contractABI,
        address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
        functionName: "createMarket",
        args: [marketData],
        value: requiredFee,
      });
      

      
      // Fix: Subtract 1 to get the correct market ID
      const marketid =
        (await readContract(config, {
          abi: contractABI,
          address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
          functionName: "getTotalMarketsCount",
          chainId: base.id,
        })) - 1; // Now correctly gets the new market ID
      const updatePoints = async (marketid) => {
        try {
          const response = await axios.get(
            `https://rafiki-launchpad.devligence.com/points/track/${marketid}/`
          );
          
          
        } catch (error) {
          console.error("Error fetching user points", error);
        }
      };

      updatePoints(Number(marketid));

      toast.success('🦄 "Market Created Successfully!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      // alert("Market Created Successfully!");
      window.location.reload();
    } catch (error) {
      // alert("Kindly try again and ensure you have enough for fee & gas");
      toast.error('🦄 "Kindly try again and ensure you have enough for fee & gas!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} xl={5}>
            <VuiBox
              component="form"
              role="form"
              onSubmit={handleSubmit(onSubmit)}
              sx={{
                background: "rgba(0, 0, 0, 0.2)",
                borderRadius: "15px",
                padding: "24px",
                backdropFilter: "blur(10px)",
              }}
            >
              <VuiTypography variant="h5" color="white" fontWeight="bold" mb={3}>
                Create New Market
              </VuiTypography>

              {/* Market Name */}
              <VuiBox mb={3}>
                <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                  Market Name
                </VuiTypography>
                <GradientBorder minWidth="100%" padding="1px" borderRadius="10px">
                  <VuiInput
                    type="text"
                    placeholder="Enter market name"
                    {...register("marketName")}
                    sx={{ height: "45px", color: "white" }}
                  />
                </GradientBorder>
                {errors.marketName && (
                  <VuiTypography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                    {errors.marketName.message}
                  </VuiTypography>
                )}
              </VuiBox>

              {/* Token Selection Section */}
              <VuiBox
                sx={{
                  display: "flex",
                  gap: "16px",
                  flexDirection: { xs: "column", sm: "row" },
                  mb: 3,
                }}
              >
                {/* Mother Token */}
                <VuiBox flex={1}>
                  <VuiTypography
                    component="label"
                    variant="button"
                    color="white"
                    fontWeight="medium"
                  >
                    Mother Token
                  </VuiTypography>
                  <GradientBorder minWidth="100%" padding="1px" borderRadius="10px">
                    <VuiInput
                      type="text"
                      value={masterTokenName}
                      placeholder="Search token..."
                      readOnly
                      onClick={() => handleSearchOpen("master")}
                      sx={{
                        height: "45px",
                        cursor: "pointer",
                        background: "url('/assets/search-icon.svg') no-repeat 95% center",
                        backgroundSize: "16px",
                      }}
                    />
                  </GradientBorder>
                  {errors.masterToken && (
                    <VuiTypography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                      {errors.masterToken.message}
                    </VuiTypography>
                  )}
                </VuiBox>

                {/* Child Token */}
                <VuiBox flex={1}>
                  <VuiTypography
                    component="label"
                    variant="button"
                    color="white"
                    fontWeight="medium"
                  >
                    Child Token
                  </VuiTypography>
                  <GradientBorder minWidth="100%" padding="1px" borderRadius="10px">
                    <VuiInput
                      type="text"
                      value={childTokenName}
                      placeholder="Search token..."
                      readOnly
                      onClick={() => handleSearchOpen("child")}
                      sx={{
                        height: "45px",
                        cursor: "pointer",
                        background: "url('/assets/search-icon.svg') no-repeat 95% center",
                        backgroundSize: "16px",
                      }}
                    />
                  </GradientBorder>
                  {errors.childToken && (
                    <VuiTypography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                      {errors.childToken.message}
                    </VuiTypography>
                  )}
                </VuiBox>
              </VuiBox>

              {/* TVL Inputs Section */}
              <VuiBox
                sx={{
                  display: "flex",
                  gap: "16px",
                  flexDirection: { xs: "column", sm: "row" },
                  mb: 4,
                }}
              >
                {/* Mother TVL */}
                <VuiBox flex={1}>
                  <VuiTypography
                    component="label"
                    variant="button"
                    color="white"
                    fontWeight="medium"
                  >
                    Mother Incentive Cap (TVL)
                  </VuiTypography>
                  <GradientBorder minWidth="100%" padding="1px" borderRadius="10px">
                    <VuiInput
                      type="number"
                      placeholder="Enter number of Tokens"
                      {...register("motherTvl")}
                      sx={{ height: "45px", color: "white" }}
                    />
                  </GradientBorder>
                  <VuiBox sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                    <VuiTypography
                      component="span"
                      variant="caption"
                      color="text"
                      fontWeight="medium"
                    >
                      $
                      {mothertvlAmount
                        ? (masterToken.priceUsd * parseFloat(mothertvlAmount)).toLocaleString()
                        : "0.00"}
                    </VuiTypography>
                  </VuiBox>
                  {errors.motherTvl && (
                    <VuiTypography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                      {errors.motherTvl.message}
                    </VuiTypography>
                  )}
                </VuiBox>

                {/* Child TVL */}
                <VuiBox flex={1}>
                  <VuiTypography
                    component="label"
                    variant="button"
                    color="white"
                    fontWeight="medium"
                  >
                    Child Target (TVL)
                  </VuiTypography>
                  <GradientBorder minWidth="100%" padding="1px" borderRadius="10px">
                    <VuiInput
                      type="number"
                      placeholder="Enter number of Tokens"
                      {...register("childTvl")}
                      sx={{ height: "45px", color: "white" }}
                    />
                  </GradientBorder>
                  <VuiBox sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                    <VuiTypography
                      component="span"
                      variant="caption"
                      color="text"
                      fontWeight="medium"
                    >
                      $
                      {childtvlAmount
                        ? (childToken.priceUsd * parseFloat(childtvlAmount)).toLocaleString()
                        : "0.00"}
                    </VuiTypography>
                  </VuiBox>
                  {errors.childTvl && (
                    <VuiTypography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                      {errors.childTvl.message}
                    </VuiTypography>
                  )}
                </VuiBox>
              </VuiBox>

              {/* Token Details Section */}
              {(masterToken?.baseToken?.address || childToken?.baseToken?.address) && (
                <VuiBox
                  mb={4}
                  sx={{
                    background: "rgba(255, 255, 255, 0.05)",
                    borderRadius: "10px",
                    padding: "16px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(5px)",
                  }}
                >
                  <VuiTypography variant="button" color="white" fontWeight="bold" mb={2}>
                    Token Details
                  </VuiTypography>

                  <VuiBox
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                      gap: "24px",
                    }}
                  >
                    {/* Mother Token Details */}
                    {masterToken?.baseToken?.address && (
                      <VuiBox>
                        <VuiBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 2,
                            p: 1,
                            background: "rgba(0, 0, 0, 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          {masterToken.info?.imageUrl && (
                            <VuiBox
                              component="img"
                              src={masterToken.info?.imageUrl}
                              alt={masterToken.baseToken.name}
                              width="24px"
                              height="24px"
                              mr={1}
                            />
                          )}
                          <VuiTypography variant="button" color="white" fontWeight="medium">
                            {masterToken.baseToken.name} ({masterToken.baseToken.symbol}) /{" "}
                            {masterToken.quoteToken.name} ({masterToken.quoteToken.symbol})
                          </VuiTypography>
                        </VuiBox>

                        <VuiBox sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Address:
                            </VuiTypography>
                            <VuiTypography
                              variant="caption"
                              color="white"
                              sx={{
                                maxWidth: "140px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor: "pointer",
                                "&:hover": { color: "primary.main" },
                              }}
                              onClick={() =>
                                window.open(
                                  `https://basescan.org/address/${masterToken.baseToken.address}`,
                                  "_blank"
                                )
                              }
                            >
                              {shortenAddress(masterToken.baseToken.address)}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Chain:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              {getChainIcon(masterToken.chainId) || "n/a"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Circulating Supply(24h):
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              {masterToken.volume?.h24.toLocaleString() || "0"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              FDV:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              ${masterToken.fdv?.toLocaleString() || "0.00"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Liquidity:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              ${masterToken.liquidity?.usd.toLocaleString() || "0.00"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Holders:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              ~ {masterToken.holdersCount || "0"}
                            </VuiTypography>
                          </VuiBox>
                        </VuiBox>
                      </VuiBox>
                    )}

                    {/* Child Token Details */}
                    {childToken?.baseToken?.address && (
                      <VuiBox>
                        <VuiBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 2,
                            p: 1,
                            background: "rgba(0, 0, 0, 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          {childToken.info?.imageUrl && (
                            <VuiBox
                              component="img"
                              src={childToken.info?.imageUrl}
                              alt={childToken.baseToken.name}
                              width="24px"
                              height="24px"
                              mr={1}
                            />
                          )}
                          <VuiTypography variant="button" color="white" fontWeight="medium">
                            {childToken.baseToken.name} ({childToken.baseToken.symbol}) /{" "}
                            {childToken.quoteToken.name} ({childToken.quoteToken.symbol})
                          </VuiTypography>
                        </VuiBox>

                        <VuiBox sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Address:
                            </VuiTypography>
                            <VuiTypography
                              variant="caption"
                              color="white"
                              sx={{
                                maxWidth: "140px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor: "pointer",
                                "&:hover": { color: "primary.main" },
                              }}
                              onClick={() =>
                                window.open(
                                  `https://basescan.org/address/${childToken.baseToken.address}`,
                                  "_blank"
                                )
                              }
                            >
                              {shortenAddress(childToken.baseToken.address)}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Chain:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              {getChainIcon(childToken.chainId) || "n/a"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Circulating Supply(24h):
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              {childToken.volume?.h24.toLocaleString() || "0"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              FDV:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              ${childToken.fdv?.toLocaleString() || "0.00"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Liquidity:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              ${childToken.liquidity?.usd.toLocaleString() || "0.00"}
                            </VuiTypography>
                          </VuiBox>

                          <VuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
                            <VuiTypography variant="caption" color="text">
                              Holders:
                            </VuiTypography>
                            <VuiTypography variant="caption" color="white">
                              ~ {childToken.holdersCount || "0"}
                            </VuiTypography>
                          </VuiBox>
                        </VuiBox>
                      </VuiBox>
                    )}
                  </VuiBox>
                </VuiBox>
              )}

              {/* Submit Button */}
              <VuiBox>
                {wallet.address ? (
                  <VuiButton
                    type="submit"
                    color="info"
                    fullWidth
                    sx={{
                      height: "48px",
                      fontSize: "14px",
                      boxShadow: "0 0 10px rgba(0, 191, 255, 0.5)",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 0 15px rgba(0, 191, 255, 0.7)",
                      },
                    }}
                  >
                    Create Market
                  </VuiButton>
                ) : (
                  <VuiBox sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <ConnectKitButton theme="soft" label="Connect to Merge" />
                  </VuiBox>
                )}
              </VuiBox>
            </VuiBox>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Card>
              <VuiBox sx={{ height: "100%" }}>
                <VuiBox display="flex" justifyContent="space-between" alignItems="center">
                  <VuiTypography variant="lg" color="white" fontWeight="bold">
                    Market Analysis
                  </VuiTypography>{" "}
                </VuiBox>

                <VuiBox sx={{ height: "510px" }}>
                  <MarketChart motherTokenData={masterToken} childTokenData={childToken} />
                </VuiBox>

                <VuiBox mt={3}>
                  <VuiBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                    <TokenData
                      item=""
                      id=""
                      master={`${masterToken?.baseToken?.name || ""} (mother)`}
                      child={`${childToken?.baseToken?.name || ""} (child)`}
                      merge=""
                    />
                    <Divider light />
                    <TokenData
                      item="Chain"
                      id="#MS-415646"
                      master={getChainIcon(masterToken?.chainId)}
                      child={getChainIcon(childToken?.chainId)}
                      merge=""
                    />
                    <TokenData
                      item="Dex"
                      id="#MS-415646"
                      master={
                        <img
                          src={`https://dd.dexscreener.com/ds-data/dexes/${masterToken?.dexId}.png`}
                          width={20}
                          height={20}
                          alt={masterToken?.dexId}
                        />
                      }
                      child={
                        <img
                          src={`https://dd.dexscreener.com/ds-data/dexes/${childToken?.dexId}.png`}
                          width={20}
                          height={20}
                          alt={childToken?.dexId}
                        />
                      }
                      merge=""
                    />
                    <TokenData
                      item="Token"
                      id="#MS-415086"
                      master={shortenAddress(masterToken.baseToken?.address)}
                      child={shortenAddress(childToken.baseToken?.address)}
                      merge=""
                    />
                    <TokenData
                      item="Circulating Supply(24h)"
                      id="#MS-415686"
                      master={masterToken.volume?.h24.toLocaleString() || "0"}
                      child={childToken.volume?.h24.toLocaleString() || "0"}
                      merge=""
                    />
                    <TokenData
                      item="Price"
                      id="#MS-415646"
                      master={formatCurrency(masterToken?.priceUsd)}
                      child={formatCurrency(childToken?.priceUsd)}
                      merge=""
                    />
                    <TokenData
                      item="Liquidity"
                      id="#MS-415646"
                      master={formatCurrency(masterToken?.liquidity?.usd)}
                      child={formatCurrency(childToken?.liquidity?.usd)}
                      merge=""
                    />
                    <TokenData
                      item="FDV"
                      id="#RV-126749"
                      master={formatCurrency(masterToken?.fdv)}
                      child={formatCurrency(childToken?.fdv)}
                      merge=""
                    />
                    <TokenData
                      item="Mkt Cap"
                      id="#QW-103578"
                      master={formatCurrency(masterToken?.marketCap)}
                      child={formatCurrency(childToken?.marketCap)}
                      merge=""
                    />
                    <TokenData
                      item="Holders"
                      id="#RV-126789"
                      master={`~ ${masterToken?.holdersCount}`}
                      child={`~ ${childToken?.holdersCount}`}
                      merge=""
                    />
                    {/* <TokenData item="Holders" id="#MS-415696" 
                    master={`$ ${masterToken?.marketCap}`}
                    child={`$ ${childToken?.price}`}
                     merge="20k" /> */}
                    <TokenData
                      item="Pair"
                      id="#AR-803481"
                      master={shortenAddress(masterToken?.pairAddress)}
                      child={shortenAddress(childToken?.pairAddress)}
                      merge=""
                      noGutter
                    />
                    <TokenData
                      item="Creation Date"
                      id="#MS-415646"
                      master={formatTimeDifference(Number(masterToken?.pairCreatedAt))}
                      child={formatTimeDifference(Number(childToken?.pairCreatedAt))}
                      merge=""
                    />

                    <TokenData
                      item="Audit Score"
                      id="#MS-415646"
                      master="No Issues"
                      child="No Issues"
                      merge=""
                    />
                  </VuiBox>
                </VuiBox>
                {/* <Stack
                  mt="25px"
                  justifyContent="center"
                  alignItems="center"
                  direction="row"
                  spacing={2}
                >
                  <GradientBorder borderRadius="xl">
                    <a href="#">
                      <IconButton
                        transition="all .25s ease"
                        justify="center"
                        align="center"
                        bg="rgb(19,21,54)"
                        borderradius="15px"
                        sx={({ palette: { secondary }, borders: { borderRadius } }) => ({
                          borderRadius: borderRadius.xl,
                          padding: "10px",
                          backgroundColor: secondary.focus,
                          "&:hover": {
                            backgroundColor: rgba(secondary.focus, 0.9),
                          },
                        })}
                      >
                        <Icon
                          as={FaTelegram}
                          w="10px"
                          h="10px"
                          sx={({ palette: { white } }) => ({
                            color: white.focus,
                          })}
                        />
                        <VuiTypography variant="button" color="text" fontWeight="regular" ml="5px">
                          Telegram
                        </VuiTypography>
                      </IconButton>
                    </a>
                  </GradientBorder>
                  <GradientBorder borderRadius="xl">
                    <a href="#">
                      <IconButton
                        transition="all .25s ease"
                        justify="center"
                        align="center"
                        bg="rgb(19,21,54)"
                        borderradius="15px"
                        sx={({ palette: { secondary }, borders: { borderRadius } }) => ({
                          borderRadius: borderRadius.xl,
                          padding: "10px",
                          backgroundColor: secondary.focus,
                          "&:hover": {
                            backgroundColor: rgba(secondary.focus, 0.9),
                          },
                        })}
                      >
                        <Icon
                          as={FaTwitter}
                          w="10px"
                          h="10px"
                          sx={({ palette: { white } }) => ({
                            color: white.focus,
                          })}
                        />
                        <VuiTypography variant="button" color="text" fontWeight="regular" ml="5px">
                          Twitter
                        </VuiTypography>
                      </IconButton>
                    </a>
                  </GradientBorder>
                  <GradientBorder borderRadius="xl">
                    <a href="#">
                      <IconButton
                        transition="all .25s ease"
                        justify="center"
                        align="center"
                        bg="rgb(19,21,54)"
                        borderradius="15px"
                        sx={({ palette: { secondary }, borders: { borderRadius } }) => ({
                          borderRadius: borderRadius.xl,
                          padding: "10px",
                          backgroundColor: secondary.focus,
                          "&:hover": {
                            backgroundColor: rgba(secondary.focus, 0.9),
                          },
                        })}
                      >
                        <Icon
                          as={FaGlobe}
                          w="10px"
                          h="10px"
                          sx={({ palette: { white } }) => ({
                            color: white.focus,
                          })}
                        />
                        <VuiTypography variant="button" color="text" fontWeight="regular" ml="5px">
                          Website
                        </VuiTypography>
                      </IconButton>
                    </a>
                  </GradientBorder>
                </Stack> */}
              </VuiBox>
            </Card>
          </Grid>
        </Grid>
      </VuiBox>

      {/* Search Modal */}
      <Dialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        maxWidth="xl"
        sx={{
          "& .MuiDialog-paper": {
            top: "10%",
            margin: 0,
            position: "absolute",
            background: "transparent",
          },
        }}
      >
        <DialogContent>
          <Card>
            {/* Search Input */}
            <VuiBox display="flex" alignItems="center" width="100%" mb={2}>
              <VuiInput
                variant="outlined"
                placeholder="Search token by name or address"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  flexGrow: 1, // Allows input to take available space without pushing the button
                }}
              />
              <IconButton onClick={() => setSearchOpen(false)} color="white" sx={{ ml: 1 }}>
                ✖
              </IconButton>
            </VuiBox>

            {/* Show Grid if No Search Query, List if Searching */}
            {loading ? (
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                style={{ width: "100%", minHeight: "60vh", textAlign: "center" }}
              >
                <Grid item xs={12}>
                  <VuiTypography variant="button" color="white">
                    Loading...
                  </VuiTypography>
                </Grid>
              </Grid>
            ) : searchQuery === "" ? (
              // GRID VIEW (Default API)
              <Grid container spacing={2}>
                {defaultTokens.map((token) => (
                  <Grid item xs={12} sm={6} md={6} key={token.address}>
                    <Card>
                      <TokenCards token={token} handleSelectToken={handleSelectToken} />
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              // LIST VIEW (Search API)
              <List>
                {searchResults.map((token, index) => (
                  <ListItem
                    button
                    key={index}
                    onClick={() => handleSelectToken(token)}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      padding: "16px",
                      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                    }}
                  >
                    {/* "chainId": "cronos",
                     "dexId": "vvsfinance", */}
                    <VuiBox
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      {getChainIcon(token?.chainId)}
                      <img
                        src={`https://dd.dexscreener.com/ds-data/dexes/${token?.dexId}.png`}
                        width={20}
                        height={20}
                        alt={token?.dexId}
                      />
                    </VuiBox>
                    <ListItemAvatar>
                      <VuiBox
                        sx={{
                          width: 60, // Adjust size
                          height: 60,
                          borderRadius: "8px", // Optional: Add rounded corners
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          ml: 1,
                          mr: 2,
                          backgroundColor: token?.info?.imageUrl
                            ? "transparent"
                            : "rgba(255,255,255,0.1)", // Light background if no image
                        }}
                      >
                        {token?.info?.imageUrl ? (
                          <img
                            src={token.info.imageUrl}
                            alt={token?.symbol || "Token"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <VuiTypography variant="body2" color="white">
                            ?
                          </VuiTypography> // Show '?' if no image
                        )}
                      </VuiBox>
                    </ListItemAvatar>

                    <ListItemText
                      primary={`${token?.baseToken?.symbol} / ${token?.quoteToken?.symbol} ${token?.baseToken?.name}`}
                      primaryTypographyProps={{ style: { color: "white" } }}
                      secondary={
                        <VuiBox display="flex" gap={10} mt={2}>
                          {[
                            { label: "Market Cap", value: token?.marketCap },
                            { label: "Liquidity", value: token?.liquidity?.usd },
                            { label: "24H Volume", value: token?.volume?.h24 },
                            { label: "FDV", value: token?.fdv },
                          ].map((item, index) => (
                            <VuiBox
                              key={index}
                              sx={{
                                backgroundColor: "rgba(108, 118, 209, 0.14)",
                                padding: "6px 12px",
                                borderRadius: "8px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                minWidth: "100px",
                              }}
                            >
                              <VuiTypography variant="caption" color="white">
                                {item.label}:
                              </VuiTypography>
                              <VuiTypography variant="caption" color="white" ml={1}>
                                {formatCurrency(item.value)}
                              </VuiTypography>
                            </VuiBox>
                          ))}
                          <VuiBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                            <VuiTypography variant="caption" noWrap mb={2}>
                              PAIR: {shortenAddress(token?.pairAddress)}
                            </VuiTypography>
                            <VuiTypography variant="caption" noWrap>
                              TOKEN: {shortenAddress(token?.baseToken?.address)}
                            </VuiTypography>
                          </VuiBox>
                        </VuiBox>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Card>
        </DialogContent>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

export default MarketCreate;
